import { CAMPANHA_URL, CARTEIRA_URL } from "domain/infra/data/env";
import { CampanhaProps } from "./campanhaProps";
import { DomainConstants } from "domain/infra/data/domainConstants";

class CampanhaConstants extends DomainConstants {
  public apiCampanha: CampanhaProps;

  constructor() {
    super(1000);

    // const api_exemplo_info = {
    //   //campanhaUrl: env.CampanhaApiSe existir,
    // } as CampanhaProps;

    this.apiCampanha = {
      ...this.apiDomain,

      campanhaExemplo: {
        getExemploByUsuario: `${this.api.baseUrl}/exemplo/getExemploByUsuario`
      },
      DuploFator: {
        enviarZap: `${CAMPANHA_URL}/CampanhaDuploFator/enviar-codigo-sms`,
      },
      CampanhasUsuario: {
        GetAtivosByUsuarioPagador: `${this.api.baseUrl}/Campanha/GetAtivosByUsuarioPagador`,
        GetAllByUsuario: `${this.api.baseUrl}/Campanha/GetAllAgrupadasByUsuario`,
        aprovarResgate: `${CAMPANHA_URL}/campanhapedidoresgate/AlterarStatus`,
        reprovarResgate: `${CAMPANHA_URL}/campanhapedidoresgate/ReprovarPedido`,
        getCampanhaUsuario: `${CAMPANHA_URL}/campanhaUsuario/GetOne`
      },
      CampanhaAprovarPedido: {
        aprovarPedido: `${CAMPANHA_URL}/xxx/xx`,
        teste: `${CAMPANHA_URL}/xx/xx`
      },
      CampanhaPagarPedido: {
        pagar: `${CAMPANHA_URL}/CampanhaPedidoResgatePagamento/Pagar`,
        tentarNovamente: `${CAMPANHA_URL}/CampanhaPedidoResgatePagamento/TentarNovamente`,
      },
      CampanhaLotePedido: {
        getLotes: `${CAMPANHA_URL}/CampanhaPedidoResgatePagamento/GetAll`,
        getResgatesByLotes: `${CAMPANHA_URL}/CampanhaPedidoResgate/lote`, // aaaa
        getLoteById: `${CAMPANHA_URL}/CampanhaPedidoResgatePagamento`,
        criarLote: `${CAMPANHA_URL}/CampanhaPedidoResgatePagamento`,
        deletar: `${CAMPANHA_URL}/CampanhaPedidoResgatePagamento/`,
        getComprovantePdf: `${CARTEIRA_URL}/Carteira/`
      },
      CampanhaPedidoResgate: {
        extrato: `${CAMPANHA_URL}/campanhaPedidoResgate/extrato`,
        notaRepasse: `${CAMPANHA_URL}/CampanhaPedidoResgate/nota-repasse`
      },
      CampanhaPedidoResgatePagamentoDeposito: {
        getCampanhaPedidoResgatePagamento(campanhaPedidoResgatePagamentoId: number): string {
          //return `${CAMPANHA_URL}/campanhaPedidoResgatePagamentoDeposito/${campanhaPedidoResgatePagamentoId}`;
          return `${CAMPANHA_URL}/campanhaPedidoResgatePagamentoDeposito/By-Pagamento/${campanhaPedidoResgatePagamentoId}`;
        },
        getCampanhaPedidoResgatePagamentoDepositoBoleto(campanhaPedidoResgatePagamentoId: number, carteiraId: number): string {
          return `${CAMPANHA_URL}/campanhaPedidoResgatePagamentoDeposito/deposito/${campanhaPedidoResgatePagamentoId}?carteiraId=${carteiraId}`;
        },
        getCampanhaPedidoResgatePagamentoDepositoPix(campanhaPedidoResgatePagamentoId: number, carteiraId: number): string {
          return `${CAMPANHA_URL}/campanhaPedidoResgatePagamentoDeposito/depositoPix/${campanhaPedidoResgatePagamentoId}?carteiraId=${carteiraId}`;
        },
        pixCheckSSE(codigoInterno: string): string {
          return `${CAMPANHA_URL}/campanhaPedidoResgatePagamentoDeposito/pix-check-SSE/?codigoInterno=${codigoInterno}`;
        },

        enviarEmail: `${CAMPANHA_URL}/CampanhaPedidoResgate/enviar-email`
      },
    } as CampanhaProps
  }
}

export default new CampanhaConstants();
